import { defineStore } from 'pinia'
import backendHandler from '@/BackendAPI.js'
import { useInstanceStore } from '@/store/backendInstances.js'

export const useNetworkDeviceStore = defineStore('networkDevices', {
  state: () => ({}),
  persist: false,
  share: {
    enable: false,
    initialize: false,
  },
  getters: {},
  actions: {
    async queryNetworkDevices(payload = {}, globalUniqueIdentifier = useInstanceStore().selectedInstanceId) {
      const networkDeviceResponse = await backendHandler.post(globalUniqueIdentifier, {
        path: '/api/network/devices/query',
        data: payload,
      })
      if (!networkDeviceResponse.ok) return null
      return networkDeviceResponse.data
    },

    async loadPortInformation(networkDeviceId, globalUniqueIdentifier = useInstanceStore().selectedInstanceId) {
      const portInformationResponse = await backendHandler.get(globalUniqueIdentifier, {
        path: `/api/network/devices/administration/${networkDeviceId}/ports`,
      })
      if (!portInformationResponse.ok) return null
      return portInformationResponse.data
    },
    async loadConnectedClients(networkDeviceId, globalUniqueIdentifier = useInstanceStore().selectedInstanceId) {
      const connectedClientsResponse = await backendHandler.get(globalUniqueIdentifier, {
        path: `/api/network/devices/administration/${networkDeviceId}/clients`,
      })
      if (!connectedClientsResponse.ok) return null
      return connectedClientsResponse.data
    },

    /**
     * Sets the status of one or multiple ports of a network device
     * @param networkDeviceId Database Id of the network device
     * @param status Object with port names as keys and boolean values indicating the status
     * @param globalUniqueIdentifier
     * @returns {Promise<*|null>}
     */
    async setPortStatus(networkDeviceId, status, globalUniqueIdentifier = useInstanceStore().selectedInstanceId) {
      const setPortStatusResponse = await backendHandler.patch(globalUniqueIdentifier, {
        path: `/api/network/devices/administration/${networkDeviceId}/ports`,
        data: status,
      })
      if (!setPortStatusResponse.ok) return null
      return setPortStatusResponse.data
    },

    /**
     * Sets the Power over Ethernet (PoE) status for a one ore multiple ports of a network device
     * @param networkDeviceId Database Id of the network device
     * @param status Object with port names as keys and boolean values indicating the PoE status
     * @param globalUniqueIdentifier
     * @returns {Promise<void>}
     */
    async setPortPOEStatus(networkDeviceId, status, globalUniqueIdentifier = useInstanceStore().selectedInstanceId) {
      const setPortPOEStatusResponse = await backendHandler.patch(globalUniqueIdentifier, {
        path: `/api/network/devices/administration/${networkDeviceId}/ports/poe`,
        data: status,
      })
      if (!setPortPOEStatusResponse.ok) return null
      return setPortPOEStatusResponse.data
    },

    async lockPortToMacAddress(networkDeviceId, portName, macAddress, globalUniqueIdentifier = useInstanceStore().selectedInstanceId) {
      const lockPortResponse = await backendHandler.put(globalUniqueIdentifier, {
        path: `/api/network/devices/administration/${networkDeviceId}/port-lock`,
        data: {
          portName: portName,
          macAddress: macAddress,
        },
      })
      if (!lockPortResponse.ok) return null
      return lockPortResponse.data
    },
    async unlockPort(networkDeviceId, portName, globalUniqueIdentifier = useInstanceStore().selectedInstanceId) {
      const unlockPortResponse = await backendHandler.delete(globalUniqueIdentifier, {
        path: `/api/network/devices/administration/${networkDeviceId}/port-lock`,
        data: {
          portName: portName,
        },
      })
      if (!unlockPortResponse.ok) return null
      return unlockPortResponse.data
    },
  },
})
